import axios, { type AxiosInstance } from 'axios'

import type { ApiResult, PartnerCreator } from '@/models/interfaces'
import { APP_VERSION, BACKEND_URL, BACKEND_TIMEOUT } from '@/init/settings'

function getPublicApiBaseUrl(): string {
  let backend = BACKEND_URL
  if (
    backend.startsWith('http://localhost') &&
    window.location.hostname !== '127.0.0.1'
  ) {
    backend = backend.replace('localhost', window.location.hostname)
  }
  return `${backend}/api/`
}

/**
 * Axios client for unauthenticated public API endpoints.
 * Intentionally separate from services/request.ts (no auth or Sentry interceptors).
 */
export const publicRequest: AxiosInstance = axios.create({
  baseURL: getPublicApiBaseUrl(),
  timeout: parseInt(BACKEND_TIMEOUT, 10),
  headers: {
    'Content-Type': 'application/json',
    'X-Sf-Client': APP_VERSION,
  },
})

/** Public API helpers (safe for public page bundles). */
export const backendPublic = {
  async getPartnerCreator(utm_source: string): Promise<PartnerCreator> {
    const response = await publicRequest.get<ApiResult<PartnerCreator>>(
      `system/public/partner_creators/${encodeURIComponent(utm_source)}`,
    )
    return response.data.data
  },
}
